// extracted by mini-css-extract-plugin
export default {"hiddenMobile":"_15XMt","hiddenDesktop":"_2E4Or"};